import { render, staticRenderFns } from "./TelecomRecsBlock.vue?vue&type=template&id=10b66e7a"
import script from "./TelecomRecsBlock.vue?vue&type=script&lang=js"
export * from "./TelecomRecsBlock.vue?vue&type=script&lang=js"
import style0 from "./TelecomRecsBlock.vue?vue&type=style&index=0&id=10b66e7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports